export const productsFeedsRowsPerPage = [10, 20, 50];

export const TAB_INGESTION_TO_CYMBIO = 'Ingestion to Cymbio';
export const TAB_CHANNELS = 'Channels';

export const ProductFeedsStatuses = {
  PROCESSING: 'processing',
  CREATED: 'created',
  FAILED: 'failed',
};

export const spreadDescriptionBullets = {
  source_field: 'description_bullets',
  destination_field: 'description_bullets',
  string_transformers: [
    {
      type: 'spread',
      value: 'bullet',
      spread_len: 7,
    },
  ],
};

export const splittedDescriptionBullets = {
  destination: 'description_bullets',
  transformers: [
    {
      type: 'split_by_li',
    },
  ],
};

export const splitByCharacterTransformer = {
  type: 'split_by_character',
  value: ',',
};
